module.exports = __webpack_public_path__ + "static/media/chaitanya.d449905b.png";